import { AxiosProgressEvent } from 'axios';

/**
 * Takes an Axios progress event and returns the % completed value expressed as a whole number.
 * @param {{loaded: number, total: number}} progressEvent
 * @constructor
 */
export function calculateUploadProgress(progressEvent: AxiosProgressEvent) {
  if (!progressEvent.total) {
    return 0;
  }

  return Math.round((progressEvent.loaded * 100) / progressEvent.total);
}

